import {
  BookableDatesInfo,
  IBookableDate,
  IBookableDatesInfo,
  IHoliday,
} from "@/domain/entities/book";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";
import {
  HttpBookableDate,
  HttpBookableDatesInfo,
  HttpHoliday,
  IBookableDatesInfoParser,
} from "../bookRepository.types";

function parseBookableDates(dates: Array<HttpBookableDate>): IBookableDate[] {
  const bookableDates: IBookableDate[] = [];
  dates.map((date) => {
    let seatNo = undefined;
    if (date.myBooks) {
      seatNo = date.myBooks?.[0]?.seatNo;
    }
    const remainingSeatsCount = date.seatCount - date.bookSeatCount;
    const bookableDate: IBookableDate = {
      no: date.no,
      date: date.date,
      totalSeatsCount: date.seatCount,
      bookedSeatsCount: date.bookSeatCount,
      remainingSeatsCount: remainingSeatsCount < 0 ? 0 : remainingSeatsCount,
      maxBookSeatsCount: date.maxBookSeatCount,
      myBookedSeatsCount: date.myBookRangeCount,
      myBookableSeatsCount: date.maxBookRangeCount - date.myBookRangeCount,
      seatsSelectable: date.memberSeatAssignYn,
      busLayoutId: date.allocs?.[0]?.busLayoutUid ?? "",
      allocUid: date.allocs?.[0]?.allocUid ?? "",
      mySeatNo: seatNo,
      isBookedByMe: !!date.myBooks?.length,
      isWaitingForSeat: false, // ToDo: 예약대기 상태 추가
      targetSeatNo: date.targetSeatNo,
      targetSeatBookableYn: date.targetSeatBookableYn,
    };
    bookableDates.push(bookableDate);
  });
  return bookableDates;
}

function parseHoliday(data: HttpHoliday): IHoliday {
  return {
    date: data.date,
    displayText: data.displayText,
  };
}

@injectable()
export class BookableDatesInfoParser implements IBookableDatesInfoParser {
  constructor() {}

  toDomain(
    data: HttpBookableDatesInfo
  ): Result<IBookableDatesInfo, ParseError> {
    try {
      const infoData: IBookableDatesInfo = {
        bookableMonth: data.bookableMonth,
        bookableDates: parseBookableDates(data.bookableDates ?? []),
        calendarWeekdays: data.calendarWeekdays,
        calendarHolidays: data.calendarHolidays?.map(parseHoliday) ?? [],
        calendar: data.calendar,
      };
      const bookableDatesInfo = new BookableDatesInfo(infoData);
      return ok(bookableDatesInfo);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
